import {
    validateCharacterLength,
    validateNoUserIdentity,
    validateLowercase,
    validateUppercase,
    validateNumbers,
    validateSymbols,
} from '@itslearning/atlas/validation/passwordValidation';

export function rules(i18n, userInfo, minComplexityValue, complexity, value) {
    return {
        CharLength: {
            text: i18n.minNumCharacters(minComplexityValue[complexity]), 
            validation: validateCharacterLength(value, complexity, minComplexityValue.low, minComplexityValue.medium, minComplexityValue.strong) 
        },
        NoUserIdentity: {
            text: i18n.noUserIdentity,
            validation: validateNoUserIdentity(userInfo, value),
        },
        UppercaseChars: {
            text: i18n.uppercase,
            validation: validateUppercase(value),
        },
        LowercaseChars: {
            text: i18n.lowercase,
            validation: validateLowercase(value),
        },
        NumberChars: { text: i18n.numbers, validation: validateNumbers(value) },
        SymbolChars: { text: i18n.symbols, validation: validateSymbols(value) },
    };
}
